import { render } from "./NotificationsPanel.vue?vue&type=template&id=5917562d&scoped=true&ts=true"
import script from "./NotificationsPanel.vue?vue&type=script&lang=ts"
export * from "./NotificationsPanel.vue?vue&type=script&lang=ts"

import "./NotificationsPanel.vue?vue&type=style&index=0&id=5917562d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5917562d"]])

export default __exports__